export const programas_item = [
    {
        "programas_item_nombre" : "Protocolo Cero, para la prevención, atención y sanción del hostigamiento y acoso laboral y sexual en la administración pública del Estado del Estado.",
        "programas_item_url" : "../ProtocoloCero",
       
        "icono": "Protocolo-cero.png"
    },
    {
        "programas_item_nombre" : "Programa del Cómite de Ética y Prevención de Conflictos de Interes",
        "programas_item_url" : "../CEPCI",
        
        "icono": "Comite.png"
    }, 
    
    {
        "programas_item_nombre" : "Programa Operativo Anual",
        "programas_item_url" : "../Poa",
       
        "icono": "Poa.png"
    }, 
    {
        "programas_item_nombre" : "Convenios para Trabajadores del Estado",
        "programas_item_url" : "../Convenios",
   
        "icono": "Convenios.png"
    },

   
    {
        "programas_item_nombre" : "Exposiciones vigentes en la Sala Fernando Gamboa del Museo del Estado de Hidalgo",
        "programas_item_url" : "../Museo",  "programas_item_descripcion":"Conoce las exposiciones vigentes en la sala Fernando Gamboa del Museo del Estado de Hidalgo.",
        "icono": "Exposiciones.png"
    },
    {
        "programas_item_nombre" : "Publicación del Escribano",
        "programas_item_url" : "../Escribano",
        
        "icono": "Escribano.png"
    },
    {
        "programas_item_nombre" : "Criterios para el procedimiento de contratación ante la Oficialía Mayor de Gobierno del Estado",
        "programas_item_url" : "../Adquisiciones",
       
        "icono": "Lineamientos.png"
    },
    {
        "programas_item_nombre" : "Consultorios Médicos que conforman al Gobierno del Estado de Hidalgo",
        "programas_item_url" : "../Consultorios",
       
        "icono": "Consultorios.png"
    },



]

export const programas_item2 = [
   
    {
        "programas_item_nombre" : "Programa Especial de Desarrollo 2023-2028",
        "url" : "pdf/Programa_Especial_Desarrollo_OM_2023_2028.pdf",
        
        "icono": "Programa.png"
    },



]